import React, { useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { useTranslator } from '@front-activerse/common-components';
import type { DateRangeKey } from '../types';

const RANGE_OPTIONS: Array<{ key: DateRangeKey; labelKey: string }> = [
  { key: 'day', labelKey: 'wearablesDashboard.range.day' },
  { key: 'last_week', labelKey: 'wearablesDashboard.range.lastWeek' },
  { key: 'last_month', labelKey: 'wearablesDashboard.range.lastMonth' },
  { key: 'last_3_months', labelKey: 'wearablesDashboard.range.last3Months' },
  { key: 'previous_week', labelKey: 'wearablesDashboard.range.previousWeek' },
  { key: 'previous_month', labelKey: 'wearablesDashboard.range.previousMonth' },
];

interface Props {
  value: DateRangeKey;
  onChange: (next: DateRangeKey) => void;
}

const DateRangeSelector: React.FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslator();
  const [open, setOpen] = useState(false);

  const activeOption = RANGE_OPTIONS.find((o) => o.key === value) ?? RANGE_OPTIONS[0];

  return (
    <Dropdown isOpen={open} toggle={() => setOpen((v) => !v)} data-testid="date-range-selector">
      <DropdownToggle caret color="secondary" outline data-testid="date-range-selector-toggle">
        {t(activeOption.labelKey)}
      </DropdownToggle>
      <DropdownMenu>
        {RANGE_OPTIONS.map((option) => (
          <DropdownItem
            key={option.key}
            active={option.key === value}
            data-testid={`range-option-${option.key}`}
            onClick={() => onChange(option.key)}
          >
            {t(option.labelKey)}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default DateRangeSelector;
export { RANGE_OPTIONS };
